import './Layout.scss';

import { Loader, TopNavigation } from '@trackman/web-shared-components';
import { Can, Cannot } from 'components/Can';
import { DefaultRoutes } from 'Routes';
import { Navigate, useLocation, useNavigate } from 'react-router';
import { useState } from 'react';

import { AppPermissions } from 'constants/AppPermissions';
import AppSwitcher from 'components/AppSwitcher/AppSwitcher';
import Forbidden from 'pages/Forbidden/Forbidden';
import LoggedOutInfoModal from 'components/LoggedOutInfoModal/LoggedOutInfoModal';
import { Notifications } from 'components/Notifications';
import ProfileIconMenu from 'components/ProfileIconMenu/ProfileIconMenu';
import { useIsLoadingStartupData } from 'hooks/startupHooks';
import { useStores } from 'index';
import { useTranslation } from 'react-i18next';

type Props = {
  children: React.ReactNode;
};

const Layout = ({ children }: Props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { hasBearerToken, organizationId } = useStores().me;

  const { t } = useTranslation();

  const [displayContent, setDisplayContent] = useState(true);

  const isLoadingStartupData = useIsLoadingStartupData();
  const isMissingOrganizationRoute = location.pathname === DefaultRoutes.MissingOrganization;

  if (!organizationId && !isMissingOrganizationRoute) {
    return <Navigate to={DefaultRoutes.MissingOrganization} replace />;
  }

  return (
    <div className='layout-content-container'>
      <div className='top-navigation'>
        <TopNavigation
          appName={t('Reports')}
          navigation={[]}
          activeNavigationLabel={''}
          utilities={
            !isLoadingStartupData
              ? [
                  { key: 'profile-icon-menu', component: <ProfileIconMenu setDisplayContent={setDisplayContent} /> },
                  {
                    key: 'app-switcher-icon-menu',
                    component: <AppSwitcher setDisplayContent={setDisplayContent} />,
                  },
                ]
              : []
          }
          animated
          displayContent={displayContent}
          onLogoClick={() => navigate(DefaultRoutes.Homepage, { viewTransition: true })}
        />
      </div>
      {!displayContent && (
        <div className='spinner'>
          <Loader size='large' />
        </div>
      )}
      {hasBearerToken && (
        <div className={`content ${displayContent ? '' : 'content-hidden'}`}>
          <Notifications />
          {isMissingOrganizationRoute ? (
            children
          ) : (
            <>
              <Can need={[AppPermissions.PortalAccess]}>{children}</Can>
              <Cannot need={[AppPermissions.PortalAccess]}>
                <Forbidden />
              </Cannot>
            </>
          )}
        </div>
      )}
      <LoggedOutInfoModal />
    </div>
  );
};

export default Layout;
